export default __webpack_public_path__ + "static/media/NFT_1.83468b81.jpeg";